import Constant from '../../../constants';
import React, { lazy, Suspense, useMemo } from 'react';
import './slider.css';
import LoadingSkeletonBox from '../LoadingSkeletonBox';

// load the carousel widget only when this component is rendered
const Carousel = lazy(() => import('nuka-carousel'));

const CaasImgSlider = (props) => {
    const { sliderNumber = 1 } = props;

    const settings = useMemo(() => ({
        infinite: false,
        start: 0,
        nextDisabled: true,
        previousDisabled: true,
        pagingDotsIndices: [0],
        slideIndex: sliderNumber,
        // we wrap the carousel in an aspect-ratio box, so we don't need
        // adaptive height calculation at all.
        adaptiveHeight: false,
        heightMode: "max",
    }), [sliderNumber]);

    const getPath = (path) => (path ? process.env.PUBLIC_URL + path : "");

    const slides = useMemo(() => [
        {
            key: 'aerial',
            src: getPath(Constant.caasPermit.img1),
            alt: 'Permit for Aerial Activities',
            eager: true,
            priority: 'high',
        },
        {
            key: 'photography',
            src: getPath(Constant.caasPermit.img2),
            alt: 'Clearance for Conduct of Aerial Mapping',
        },
        {
            key: 'cranes',
            src: getPath(Constant.caasPermit.img3),
            alt: 'Clearance for Erection of Cranes',
        },
        {
            key: 'ship',
            src: getPath(Constant.caasPermit.img4),
            alt: 'Clearance for Ship Crossing',
        },
    ], []);


    return (
        <section aria-label="Permit Image Showcase" >
            {/* preload first slide so that it counts toward LCP and helps measurement */}
            {/* <link rel="preload" as="image" href={slides[0].src} type="image/avif" fetchpriority="high" /> */}


            <div className="caas-slider-wrapper">
                <Carousel {...settings}>
                    {slides.map((slide) => (
                        <img
                            key={slide.key}
                            src={slide.src}
                            alt={slide.alt}
                            width="1800" height="600"
                            loading={slide.eager ? 'eager' : 'lazy'}
                            fetchpriority={slide.priority || 'high'}
                            decoding="async"
                            className="caas-slider-img"
                        //decoding="auto"
                        />
                    ))}
                </Carousel>
            </div>
            {/* <Suspense
                fallback={
                    <div className="caas-slider-fallback">Loading…</div>
                }
            >
                <div className="caas-slider-wrapper">
                    <Carousel {...settings}>
                        {slides.map((slide) => (
                            <img
                                key={slide.key}
                                src={slide.src}
                                alt={slide.alt}
                                width="1800" height="600"
                                loading={slide.eager ? 'eager' : 'lazy'}
                                fetchpriority={slide.priority || 'high'}
                                decoding="async"
                                className="caas-slider-img"
                            //decoding="auto"
                            />
                        ))}
                    </Carousel>
                </div>
            </Suspense> */}
        </section>
    );
};
export default CaasImgSlider;
